import { API_ENDPOINTS } from "./Constants";
import { apiFetch } from "./apiHelper";

export async function addPublisher(publisherData) {
    const response = await apiFetch(API_ENDPOINTS.PUBLISHER, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(publisherData),
    });

    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Greška prilikom dodavanja izdavača");
    }

    return response.json();
}

export async function getAllPublishers() {
    const response = await apiFetch(API_ENDPOINTS.PUBLISHER);

    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Greška prilikom dohvaćanja izdavača");
    }

    return response.json();
}

export async function getPublisherById(id) {
    const response = await apiFetch(`${API_ENDPOINTS.PUBLISHER}/${id}`);

    if (!response.ok) {
        const data = await response.json();
        throw new Error(
            data.message || `Greška prilikom dohvaćanja izdavača ID=${id}`
        );
    }

    return response.json();
}

export async function updatePublisher(id, publisherData) {
    const response = await apiFetch(`${API_ENDPOINTS.PUBLISHER}/${id}`, {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(publisherData),
    });

    if (!response.ok) {
        const data = await response.json();
        throw new Error(
            data.message || `Greška prilikom ažuriranja izdavača ID=${id}`
        );
    }

    return response.json();
}

export async function deletePublisher(id) {
    const response = await apiFetch(`${API_ENDPOINTS.PUBLISHER}/${id}`, {
        method: "DELETE",
        credentials: "include",
    });

    if (!response.ok) {
        const data = await response.json();
        throw new Error(
            data.message || `Greška prilikom brisanja izdavača ID=${id}`
        );
    }

    return true;
}

export async function searchPublishers(term) {
    const response = await apiFetch(
        `${API_ENDPOINTS.PUBLISHER}/search?term=${encodeURIComponent(term)}`,
        {
            method: "GET",
            credentials: "include",
        }
    );

    if (!response.ok) {
        const data = await response.json();
        throw new Error(
            data.message ||
            `Greška prilikom pretrage izdavača po terminu: ${term}`
        );
    }

    return response.json();
}
